export default "__VITE_ASSET__DTpG32KE__"